import React, { useEffect, useState } from "react";
import "./TeamPage.css";
import Effectif from "../components/Effectif/Effectif";
import Classement from "../components/Classement/Classement";
import MatchCard from "../components/MatchCard/MatchCard";
import { fetchTeamMatches } from "../ServiceApi";
import { useLocation } from "react-router-dom";
import responsablesData from "../assets/data/responsables.json";
import ResponsablesSection from "../components/ResponsablesSection/ResponsablesSection";


const TeamPage = () => {
    const location = useLocation();
    const team = location.state?.team;
    const [upcomingMatches, setUpcomingMatches] = useState([]);
    const [playedMatches, setPlayedMatches] = useState([]);
    const [responsables, setResponsables] = useState([]);
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const [isRankingOpen, setIsRankingOpen] = useState(false);
    const [isResultsOpen, setIsResultsOpen] = useState(false);

    useEffect(() => {
        if (!team || !team.engagements || team.engagements.length === 0) return;

        const fetchMatches = async () => {
            const competition = team.engagements.find(
                (engagement) => engagement.competitionType === "CH"
            );
            if (!competition) {
                console.error("Aucune compétition de type 'CH' trouvée pour cette équipe.");
                return;
            }

            const competitionId = competition.competitionId;
            const phaseId = 1;
            const pouleId = team.displayName === "U15 - U14 A" ? 2 : 1;
            const clubId = extractNumericId(team.id);
            const matches = await fetchTeamMatches(competitionId, phaseId, pouleId, clubId);

            const played = matches.filter(
                (match) => match.home_score !== null && match.away_score !== null
            );
            const upcoming = matches.filter(
                (match) => match.home_score === null && match.away_score === null
            );

            setPlayedMatches(played);
            setUpcomingMatches(upcoming);
        };

        // Charger les responsables à partir du fichier JSON importé
        const fetchResponsables = () => {
            const teamResponsables = responsablesData[team.displayName] || [];
            setResponsables(teamResponsables);
        };

        fetchMatches();
        fetchResponsables();
    }, [team]);

    const extractNumericId = (teamId) => {
        const match = teamId.match(/\/(\d+)$/);
        return match ? parseInt(match[1], 10) : null;
    };

    const getTeamImage = (displayName) => {
        try {
            return require(`../assets/images/sections/${displayName}.jpg`);
        } catch (error) {
            console.error(`Image not found for team: ${displayName}. Using default image.`);
            return require("../assets/images/sections/default.jpg");
        }
    };

    return (
        <div className="team-page">
            {/* Bandeau Introductif */}
            <section className="intro">
                <img
                    src={getTeamImage(team.displayName)}
                    alt={team.displayName}
                    className="team-card-image"
                />
                <div className="intro-overlay">
                    <h1>{team.displayName}</h1>
                    <p>Découvrez les performances et l'actualité de l'équipe {team.displayName}.</p>
                </div>
            </section>
            {/* Section Responsables */}
            <ResponsablesSection responsables={responsables} />

            {/* Section Calendrier */}
            <div className="collapsible-section" data-aos="fade-left">
                <button
                    className={`collapsible-header ${isCalendarOpen ? "open" : ""}`}
                    onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                >
                    Calendrier des Matchs à Venir
                </button>
                <div className={`collapsible-content ${isCalendarOpen ? "" : "hidden"}`}>
                    {upcomingMatches.length > 0 ? (
                        upcomingMatches.map((match) => (
                            <MatchCard key={match.ma_no} match={match} />
                        ))
                    ) : (
                        <p className="no-results">Aucun match à venir pour l'instant.</p>
                    )}
                </div>
            </div>

            {/* Section Derniers Résultats */}
            <div className="collapsible-section" data-aos="fade-left">
                <button
                    className={`collapsible-header ${isResultsOpen ? "open" : ""}`}
                    onClick={() => setIsResultsOpen(!isResultsOpen)}
                >
                    Derniers Résultats
                </button>
                <div className={`collapsible-content ${isResultsOpen ? "" : "hidden"}`}>
                    {playedMatches.length > 0 ? (
                        playedMatches.map((match) => (
                            <MatchCard key={match.ma_no} match={match} />
                        ))
                    ) : (
                        <p className="no-results">Aucun résultat disponible.</p>
                    )}
                </div>
            </div>

            {/* Section Classement */}
            <div className="collapsible-section" data-aos="fade-right">
                <button
                    className={`collapsible-header ${isRankingOpen ? "open" : ""}`}
                    onClick={() => setIsRankingOpen(!isRankingOpen)}
                >
                    Classement Actuel
                </button>
                <div className={`collapsible-content ${isRankingOpen ? "" : "hidden"}`}>
                    {team.engagements && team.engagements[0] ? (
                        <Classement competitionId={team.engagements[0].competitionId} showTitle={false}/>
                    ) : (
                        <p className="no-results">Aucun classement disponible.</p>
                    )}
                </div>
            </div>

            {/* Présentation des Joueurs */}
            {team.players && team.players.length > 0 && (
                <Effectif players={team.players} />
            )}
        </div>
    );
};

export default TeamPage;
